import { StateCreator } from 'zustand';
import { IAppState, IQuickLinksSlice } from './stateTypes';
import HomePageExperience from '../../pages/home/hero/store/HomePageExperience';
import { IQuickLinksApiResponse } from '../../types/quickLinks';

const createQuickLinksSlice: StateCreator<IAppState, [], [], IQuickLinksSlice> = (set, get) => ({
    quickLinks: undefined,
    quickLinksLoaded: false,
    getQuickLinks: async () => {
        if (!get().visitorId) {
            get().setVisitorId();
        }

        if (!get().storeId) {
            get().setStoreId();
        }

        if (!get().ciamId) {
            await get().setCiam();
        }

        const { visitorId, storeId, experience, recentlyViewedVehicles, ciamId } = get();
        const isReturnVisit = experience !== HomePageExperience.FirstTimeVisitor;
        const engagedStockNumbers = recentlyViewedVehicles.map((v) => v.stockNumber);
        try {
            const searchParams = new URLSearchParams();
            searchParams.set('PageType', 'Home');
            searchParams.set('IsReturnVisit', isReturnVisit ? 'true' : 'false');
            searchParams.set('VisitorId', visitorId);
            searchParams.set('UserId', ciamId);
            searchParams.set('StoreId', storeId || '');
            engagedStockNumbers.forEach((sn) => {
                searchParams.append('engagedStockNumbers', sn.toString());
            });

            const response = await fetch(`/home/api/quick-links?${searchParams.toString()}`);

            if (response.ok) {
                const { displayOrder, componentType, componentKey, items }: IQuickLinksApiResponse =
                    await response.json();
                set({ quickLinks: { displayOrder, componentType, componentKey, prompts: items } });
            }
        } catch (error) {
            console.error('Failed to fetch quick links:', error);
        } finally {
            set({ quickLinksLoaded: true });
        }
    },
});

export default createQuickLinksSlice;
